import { datadogClient } from '~/@app/init/datadog'

import { TOAST_STRING } from '../constants/strings'
import { toastService } from './toast.service'

interface ErrorHandlerOptions {
  message?: string
  preventToast?: boolean
  useRemoteLogging?: boolean
  logType?: 'error' | 'warn'
}

class ErrorHandlerService {
  handle(err: unknown, options: ErrorHandlerOptions = {}) {
    const {
      message = TOAST_STRING.error,
      preventToast,
      useRemoteLogging,
      logType = 'error',
    } = options

    switch (logType) {
      case 'error':
        console.error(err)
        break
      case 'warn':
        console.warn(err)
        break
    }

    if (!preventToast) {
      toastService.error(message, { isSystemError: true })
    }

    if (useRemoteLogging) {
      if (err instanceof Error) {
        datadogClient.sendError(err, { source: 'custom' })
      } else {
        // Error 객체가 아닌 경우 문자열로 변환
        datadogClient.sendError(new Error(typeof err === 'string' ? err : JSON.stringify(err)), {
          source: 'custom',
        })
      }

      // else if (err instanceof SyntaxError) {
      //   // handle SyntaxError
      // } else if (err instanceof Error) {
      //   // handle Error
      // }
    }
  }
}

export const errorHandlerService = new ErrorHandlerService()
